var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isPromoDiscount)?_c('span',{staticClass:"c-text-c__default"},[_vm._v(_vm._s(_vm.formattedCurrency)+_vm._s(_vm.appendText))]):_c('span',{staticClass:"c-text-c__promo"},[_vm._v("-"+_vm._s(_vm.formattedCurrency)+_vm._s(_vm.appendText))])
}
var staticRenderFns = []

export { render, staticRenderFns }